// extracted by mini-css-extract-plugin
export default {"navigation":"menu_navigation__5okas","actions":"menu_actions__GhuP1","nav":"menu_nav__CnQAt","opened":"menu_opened__JKlUK"};